import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=3b660716&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b660716')) {
      api.createRecord('3b660716', component.options)
    } else {
      api.reload('3b660716', component.options)
    }
    module.hot.accept("./Register.vue?vue&type=template&id=3b660716&", function () {
      api.rerender('3b660716', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "backoffice/themes/base/src/views/Register.vue"
export default component.exports